module.exports = "/_next/static/images/icon-youqu-34978d23.png";